import { render } from "./vue-chapter-1.vue?vue&type=template&id=323ce315"
import script from "./vue-chapter-1.vue?vue&type=script&lang=js"
export * from "./vue-chapter-1.vue?vue&type=script&lang=js"

import "./vue-chapter-1.vue?vue&type=style&index=0&id=323ce315&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__